import { apiClient as api } from "./httpClient";

/** Régua de situação do topo: diz se EXISTE registro, nunca o conteúdo clínico dele. */
export interface PatientOverviewStatus {
  registrationComplete: boolean;
  diagnosisCount: number;
  lastDiagnosisDate?: string | null;
  planCount: number;
  /** Só a existência: o título do plano é clínico e não sai nesta tela (RN-529). */
  hasCurrentPlan: boolean;
  currentPlanEndDate?: string | null;
  nextScheduleDate?: string | null;
  nextScheduleTime?: string | null;
  nextScheduleProfessional?: string | null;
  lastAttendanceDate?: string | null;
  daysSinceLastAttendance?: number | null;
}

/** Os mesmos indicadores da Linha do tempo (RN-528d/e) — mesma régua no servidor. */
export interface PatientAttendanceIndicators {
  scheduled: number;
  attended: number;
  noShows: number;
  cancelledByPatient: number;
  cancelledByProfessional: number;
  cancelledByClinic: number;
  withoutRecord: number;
  attendanceRate: number;
}

export interface OverviewProfessional {
  id: string;
  name: string;
  specialty: string;
  cadence: string;
  lastAttendance?: string | null;
  nextSchedule?: string | null;
  sessionsLast90Days: number;
  active: boolean;
}

export interface OverviewSupervision {
  supervisor: string;
  supervised: string;
  startDate?: string | null;
  endDate?: string | null;
  active: boolean;
}

export interface PatientOverview {
  patientId: string;
  patientName: string;
  status: PatientOverviewStatus;
  attendance: PatientAttendanceIndicators;
  professionals: OverviewProfessional[];
  supervisions: OverviewSupervision[];
  /** Perfil com escopo `own`: os indicadores cobrem só os atendimentos de quem está logado. */
  scopedToOwnProfessional: boolean;
  /** Profissional da sessão no escopo `own` — o seletor fica travado nele (RN-529d) */
  ownProfessionalId?: string | null;
  ownProfessionalName?: string | null;
}

export interface PatientOverviewFilters {
  professionalId?: string;
  from?: string; // yyyy-MM-dd
  to?: string;
}

export const patientOverviewService = {
  get: async (patientId: string, filters?: PatientOverviewFilters): Promise<PatientOverview> => {
    const response = await api.get(`/patients/${patientId}/overview`, { params: filters });
    return response.data;
  },
};
